<app-base-modal dialogTitle="{{ allData.title }}" dialogSubTitle="{{ allData.subTitle }}" (closeEvent)="onCancel()">
  <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z8 custom-table">
    <!-- Label -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>{{ allData.labelColumnName }}</th>
      <td mat-cell *matCellDef="let element">{{ element.label }}</td>
    </ng-container>

    <!-- Aggregation -->
    <ng-container matColumnDef="aggregation">
      <th mat-header-cell class="align-text-end" *matHeaderCellDef>Aggregation</th>
      <td mat-cell class="align-text-end" *matCellDef="let element">{{ element.aggregation }}</td>
    </ng-container>

    <!-- Count -->
    <ng-container matColumnDef="count">
      <th mat-header-cell class="align-text-end" *matHeaderCellDef>Count</th>
      <td mat-cell class="align-text-end" *matCellDef="let element">{{ element.count }}</td>
    </ng-container>

    <!-- Percentage -->
    <ng-container matColumnDef="percentage">
      <th mat-header-cell class="align-text-end" *matHeaderCellDef>Percentage</th>
      <td mat-cell class="align-text-end" *matCellDef="let element">
        {{ element.percentage ? element.percentage.toFixed(2) + '%' : '0.00%' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns; let i = index"></tr>
  </table>

  <!-- This is projected by the ng-content of the app-base-modal -->
  <div panel-footer>
    <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="button-primary" (click)="downloadAsCsv()">
      <mat-icon>download</mat-icon>Download as CSV
    </button>
  </div>
</app-base-modal>
